import runAfterPageLoad from "../runAfterPageLoad";

export default function loadModernComponentsFormMultiselectAjax() {
  runAfterPageLoad(() => {
    $(".modern-components-form-multiselect-ajax:not(.hidden)").each((idx, item) => {
      initializeNewSelect2MultiselectAjax($(item));
    });
  });
}

function initializeNewSelect2MultiselectAjax(element) {
  const ajaxUrl = element.data("url");

  element.select2({
    ajax: {
      processResults(data) {
        return {
          results: data.map((item) => ({
            id: item.id,
            text: item.name,
          })),
        };
      },
      url: ajaxUrl,
    },
    delay: 250,
    minimumInputLength: 3,
    multiple: true,
    theme: "bootstrap",
    width: "100%",
  });
}
